__turbopack_context__.v({
  "back-button": "OnboardingLayout-module-scss-module__reG06G__back-button",
  "blinq-logo": "OnboardingLayout-module-scss-module__reG06G__blinq-logo",
  "blinq-logo-container": "OnboardingLayout-module-scss-module__reG06G__blinq-logo-container",
  "forward-button": "OnboardingLayout-module-scss-module__reG06G__forward-button",
  "main-section": "OnboardingLayout-module-scss-module__reG06G__main-section",
  "main-section-contents": "OnboardingLayout-module-scss-module__reG06G__main-section-contents",
  "main-section-header": "OnboardingLayout-module-scss-module__reG06G__main-section-header",
  "main-section-header-explainer": "OnboardingLayout-module-scss-module__reG06G__main-section-header-explainer",
  "main-section-header-heading": "OnboardingLayout-module-scss-module__reG06G__main-section-header-heading",
  "navigation-buttons-section": "OnboardingLayout-module-scss-module__reG06G__navigation-buttons-section",
  "navigation-section": "OnboardingLayout-module-scss-module__reG06G__navigation-section",
  "new-onboarding-layout": "OnboardingLayout-module-scss-module__reG06G__new-onboarding-layout",
  "new-side-section": "OnboardingLayout-module-scss-module__reG06G__new-side-section",
  "onboarding-layout": "OnboardingLayout-module-scss-module__reG06G__onboarding-layout",
  "side-section": "OnboardingLayout-module-scss-module__reG06G__side-section",
  "side-section-bounds": "OnboardingLayout-module-scss-module__reG06G__side-section-bounds",
  "side-section-content": "OnboardingLayout-module-scss-module__reG06G__side-section-content",
  "side-section-header": "OnboardingLayout-module-scss-module__reG06G__side-section-header",
});
